import * as ActionTypes from "../Types/ActionTypes";

export const ManualMail = (
  state = {
    isLoading: true,
    errMess: null,
    manualMail: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_MANUAL_SENDMAIL:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        manualMail: action.payload,
      };
    case ActionTypes.MANUAL_SENDMAIL_LOADING:
      return { 
        ...state, 
        isLoading: true,
         errMess: null,
         manualMail: [] 
        };

    case ActionTypes.MANUAL_SENDMAIL_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        manualMail: [],
      };

    default:
      return state;
  }
};
